document.addEventListener("DOMContentLoaded", function () {
  const numbers = document.querySelectorAll(".number");
  const modals = document.querySelectorAll(".modal");

  numbers.forEach((number) => {
    number.addEventListener("click", function () {
      const modalId = this.getAttribute("data-modal");
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = "block"; // 表示を有効化
        setTimeout(() => {
          modal.classList.add("show"); // アニメーション開始
        }, 10); // display:block の適用後にクラスを追加
      }
    });
  });

  const closeButtons = document.querySelectorAll(".modal .close");
  closeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const modal = this.closest(".modal");
      modal.classList.remove("show");
      setTimeout(() => {
        modal.style.display = "none";
      }, 300);
    });
  });

  window.addEventListener("click", function (event) {
    modals.forEach((modal) => {
      if (event.target === modal) {
        modal.classList.remove("show");
        setTimeout(() => {
          modal.style.display = "none";
        }, 300);
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const modals = document.querySelectorAll(".modal");

  modals.forEach((modal) => {
    document.body.appendChild(modal); // モーダルを<body>直下に移動
  });
});